import React from 'react'
import Confetti from 'react-confetti'

// Styles
import './styles.scss'

// Images
import ImageSun from './images/imageSun'
import ImageLogo from './images/imageLogo'

export default ({
  image,
  title,
  onClickButton,
}: {
  image: string
  title: string
  onClickButton: () => void
}) => {
  const { innerWidth: width, innerHeight: height } = window

  return (
    <>
      <div className={'course-finish'}>
        <div className={'course-finish__outer'}>
          <div className={'course-finish__outer-wrapper'}>
            <div className={'course-finish__outer-text'}>Поздравляем!</div>
            <div className={'course-finish__outer-map'}>
              <img src={image} />
            </div>
            <div className={'course-finish__outer-sun'}>
              <div className={'spin'}>
                <ImageSun />
              </div>
              <div className={'logo'}>
                <ImageLogo />
              </div>
            </div>
          </div>
          <div className={'course-finish__outer-text'}>
            Ты завершил курс «{title}» для школьников
          </div>
        </div>
        <button onClick={onClickButton} className={'course-finish__button'}>
          Начать курс заново
        </button>
      </div>
      <Confetti
        width={width}
        height={height}
        style={{ position: 'fixed', top: 0, left: 0, right: 0 }}
        recycle={false}
      />
    </>
  )
}
